import React, { useState } from "react";
import { Play, Quote } from "lucide-react";
import { testimonials } from "../mock";
import Reveal from "./Reveal";
import YouTubePlayer from "./YouTubePlayer";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "./ui/dialog";

export default function Testimonials() {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section className="relative border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl space-y-20 px-6">
        {testimonials.map((t, i) => {
          const reverse = i % 2 === 1;
          return (
            <Reveal key={i}>
              <div
                className={`grid items-center gap-10 lg:grid-cols-2 ${
                  reverse ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                {/* Text side */}
                <div>
                  <p className="mb-4 text-[13px] font-medium uppercase tracking-[0.2em] text-violet-400">
                    {t.eyebrow}
                  </p>
                  <h2 className="font-display text-[28px] font-bold leading-tight text-white sm:text-[34px]">
                    {t.heading}
                  </h2>
                  <p className="mt-4 text-[15px] leading-relaxed text-white/55">
                    {t.desc}
                  </p>
                  <div className="mt-6 rounded-2xl border border-white/[0.07] bg-white/[0.02] p-5">
                    <Quote className="h-6 w-6 text-violet-400/70" />
                    <p className="mt-3 text-[15px] italic leading-relaxed text-white/75">
                      “{t.quote}”
                    </p>
                    <p className="mt-3 text-[14px] font-semibold text-white">
                      — {t.author}
                    </p>
                  </div>
                </div>

                {/* Video side */}
                <button
                  onClick={() => setActiveVideo(t.videoId)}
                  className="group relative block w-full overflow-hidden rounded-3xl border border-white/10"
                >
                  <img
                    src={`https://img.youtube.com/vi/${t.videoId}/maxresdefault.jpg`}
                    alt={t.heading}
                    className="aspect-video w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => {
                      e.currentTarget.src = `https://img.youtube.com/vi/${t.videoId}/hqdefault.jpg`;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                  <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-black shadow-xl transition-transform duration-300 group-hover:scale-110">
                    <Play className="ml-1 h-6 w-6 fill-black" />
                  </span>
                  <span className="absolute bottom-4 right-4 rounded-md bg-black/70 px-2 py-1 text-[12px] text-white">
                    {t.duration}
                  </span>
                </button>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Dialog open={!!activeVideo} onOpenChange={(o) => !o && setActiveVideo(null)}>
        <DialogContent className="max-w-3xl border-white/10 bg-[#0d0d0f] p-2">
          <DialogTitle className="sr-only">Testimonio en video</DialogTitle>
          {activeVideo && <YouTubePlayer videoId={activeVideo} />}
        </DialogContent>
      </Dialog>
    </section>
  );
}
